import { HttpFilter } from "sol-request-angular/dist/comunicacao";
import { Equal } from "sol-request-angular/dist/comunicacao/filter/Equal";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";

export class PessoaSearch{

    nmPessoa: string;
    nrCpfCnpj: string;
    tpConcessao: number;
    limit: number;
    
    constructor(data:{nmPessoa?:string, nrCpfCnpj?:string, limit?:number,  tpConcessao?: number}){
        this.nmPessoa = data && data.nmPessoa;
        this.nrCpfCnpj = data && data.nrCpfCnpj;
        this.limit = data && data.limit;
        this.tpConcessao = data && data.tpConcessao;
    }

    getFilters():IFilter{
        let filtros:IFilter = new HttpFilter([
            new Equal('limit', 50)
        ]);

        if(this.nmPessoa){
            filtros.addFilter(new Equal('nmPessoa', this.nmPessoa));
            this.limit = 100;
        }

        if(this.nrCpfCnpj){
            filtros.addFilter(new Equal('cpfCnpj', this.nrCpfCnpj));
            this.limit = 100;
        }

        if(this.tpConcessao != null && this.tpConcessao >= 0){
            filtros.addFilter(new Equal('tpConcessao', this.tpConcessao));
            
        }

        return filtros;
    }

}
